import React, { useState, useEffect } from "react";
import SaveButton from "@/ui-controls/SaveButton";
import CancelButton from "@/ui-controls/CancelButton";
import { Grid } from "fluentui-react-grid";
import TextInput from "@/ui-controls/TextInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AppPrivilegeModel } from "@/api/privileges";

interface Props {
  isSaving: boolean;
  onSavePrivilege: (privilege: AppPrivilegeModel) => any;
  onClose?: () => any;
}

const NewAppPrivilegeForm = (props: Props) => {
  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const formik = useFormik({
    initialValues: { name: "", description: "" },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required").max(250),
      description: Yup.string().required("Description is required").max(250),
    }),
    onSubmit: (values, { resetForm }) => {
      const privilege = {
        Name: values.name,
        Description: values.description,
      } as AppPrivilegeModel;
      props.onSavePrivilege(privilege);
      resetForm({
        values: {
          name: "",
          description: "",
        },
      });
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Name"
                baseTypeProps={{
                  disabled: props.isSaving,
                  ...formik.getFieldProps("name"),
                }}
                hasError={formik.errors.name && formik.touched.name}
                errorMessage={formik.errors.name}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Description"
                baseTypeProps={{
                  disabled: props.isSaving,
                  ...formik.getFieldProps("description"),
                }}
                hasError={
                  formik.errors.description && formik.touched.description
                }
                errorMessage={formik.errors.description}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <SaveButton
                text="Save"
                baseTypeProps={{ type: "submit", disabled: props.isSaving }}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: props.isSaving }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </form>
    </>
  );
};

export default NewAppPrivilegeForm;
